import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { FieldError } from '../../../../../widgets'
import { IDateTimeProps } from './IDateTimeProps'
import { IEntity } from "../../../../../base/types"
import { InputFieldHelper } from '../InputHelper'
import clsx from 'clsx'
import { useDateTimeValidationSchema } from './DateTimeValidationSchema'
import { useFormContext } from '../../form'
import { useFormikContext } from "formik"

interface IDateTimeFieldProps extends HTMLAttributes<HTMLInputElement>, IDateTimeProps {
    name: string
}

export const DateTimeField: FC<IDateTimeFieldProps> = (props) => {
    const { id, name, placeholder, className, title, readOnly, disabled } = props
    const shape = useDateTimeValidationSchema(props)
    const { getFieldProps, errors, touched } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()

    useEffect(() => {
        if (!name || !shape) return;

        const schema = Yup.object().shape({ [name]: shape });
        updateSchema(schema);

        // eslint-disable-next-line
    }, [name, shape])

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    fieldProps = { ...fieldProps, value: InputFieldHelper.toDateTime(fieldProps.value ?? '') };

    return <>
        <input
            type='datetime-local'
            id={id}
            {...fieldProps}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            title={title}
            readOnly={readOnly}
            disabled={disabled}
        />
        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
}
